import { getPageName } from "@/constants/pageTitles";
import { useDocumentTitleOverrideValue } from "@/contexts/DocumentTitleOverrideContext";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useLocation } from "wouter";

export const DocumentTitle = () => {
  const [location] = useLocation();
  const override = useDocumentTitleOverrideValue();
  useDocumentTitle(override ?? getPageName(location));
  return null;
};
